export function getView(hasSignature) {
  return hasSignature === true ? 'RequestAction' : 'No'
}
